module.exports = __webpack_public_path__ + "static/media/8-2.cb996cd5.svg";